import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

import { TotemButton } from 'ui/Button';

import { colors } from 'styles/theme';

// Aucun site accessible : soit le compte vient d'être créé (le site existe, mais la lecture qui le liste
// n'a pas encore vu l'écriture), soit l'organisation n'a réellement aucun site ouvert à cet utilisateur.
// Dans les deux cas il n'y a PAS d'id à mettre dans l'URL — on affiche cet état au lieu de router vers
// `/totem/undefined`, qui rendait un 404 dont même un rechargement ne sortait pas.
//
// Le premier cas se résout tout seul en quelques secondes (le temps que la réplication rattrape) : on relance
// donc la lecture automatiquement quelques fois avant de laisser la main, plutôt que d'attendre un clic.
const AUTO_RETRY_DELAY_MS = 2000;
const AUTO_RETRY_ATTEMPTS = 5;

export const NoAccessibleTotem: FC<{ onRetry: () => void }> = ({ onRetry }) => {
    const [remainingAutoRetries, setRemainingAutoRetries] = useState(AUTO_RETRY_ATTEMPTS);

    useEffect(() => {
        if (!remainingAutoRetries) {
            return;
        }
        const timeout = setTimeout(() => {
            setRemainingAutoRetries((remaining) => remaining - 1);
            onRetry();
        }, AUTO_RETRY_DELAY_MS);

        return () => clearTimeout(timeout);
    }, [remainingAutoRetries, onRetry]);

    return (
        <Container data-test="no-accessible-totem">
            <Title>Aucun site accessible pour le moment</Title>
            <Description>
                Si vous venez de créer votre compte, votre site est en cours de préparation : cela ne prend que quelques
                instants.
            </Description>
            <TotemButton $fontSize="1em" onClick={onRetry}>
                Réessayer
            </TotemButton>
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
    padding: 20px;
    text-align: center;
`;

const Title = styled.span`
    font-size: 2em;
    font-weight: 700;
`;

const Description = styled.span`
    max-width: 32em;
    color: ${colors.pantinGrey};
`;
